"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumberForGoogleVoice = exports.isValidUSNumber = exports.ContactType = exports.ContactChannel = void 0;
var ContactChannel;
(function (ContactChannel) {
    ContactChannel["Email"] = "email";
    ContactChannel["Phone"] = "phone";
})(ContactChannel = exports.ContactChannel || (exports.ContactChannel = {}));
var ContactType;
(function (ContactType) {
    ContactType["Personal"] = "personal";
    ContactType["Work"] = "work";
    ContactType["Unknown"] = "unknown";
})(ContactType = exports.ContactType || (exports.ContactType = {}));
function isValidUSNumber(value) {
    return !!value.match(/^\(\d\d\d\)/);
}
exports.isValidUSNumber = isValidUSNumber;
function formatNumberForGoogleVoice(value) {
    return `1${value.replace(/[^0-9.]/g, '')}`;
}
exports.formatNumberForGoogleVoice = formatNumberForGoogleVoice;
//# sourceMappingURL=contact.js.map